import { Routes } from "../methods/ApiRoutes";

const permissions = [
  { module: Routes.Analytics.permissionKey, edit: true, delete: true, read: false, hide: ['delete', 'edit'] },
  { module: Routes.User.permissionKey, add: false, edit: false, delete: false, read: false },
  { module: Routes.Venue.permissionKey, add: false, edit: false, delete: false, read: false },
  // { module: Routes.Category.permissionKey, add: false, edit: false, delete: false, read: false },
  // { module: Routes.Devices.permissionKey, add: false, edit: false, delete: false, read: false },
  // { module: Routes.Retailers.permissionKey, add: false, edit: false, delete: false, read: false },
  { module: Routes.Offer.permissionKey, edit: false, delete: false, read: false },
  { module: Routes.Transactions.permissionKey, edit: true, delete: true, read: false, hide: ['delete', 'edit'] },
  { module: Routes.settings.permissionKey, edit: false, delete: true, read: false, hide: ['delete'] },
  { module: Routes.Content.permissionKey, edit: true, delete: true, read: true, hide: ['delete'] },
  { module: Routes.Notification.permissionKey, edit: false, delete: true, read: false, hide: ['delete'] },
]

const roleUrl = [
  {
    url: 'dashboard',
    key: 'readDashboard',
  },
  {
    url: 'roles',
    key: 'readRole',
  },
  {
    url: 'users',
    key: 'readAdmins',
  },
  {
    url: 'types',
    key: 'readTypes',
  },
  {
    url: 'categories',
    key: 'readCategory',
  },
  {
    url: 'category',
    key: 'readResellerCategory',
  },
  {
    url: 'features',
    key: 'readPlanFeatures',
  },
  {
    url: 'plans',
    key: 'readPlan',
  },
  {
    url: 'coupon',
    key: 'readCoupons',
  },
  {
    url: 'currency',
    key: 'readCurrency',
  },
  {
    url: 'bookingSystem',
    key: 'readBooking',
  },
  {
    url: 'continents',
    key: 'readContinents',
  },
  {
    url: 'countries',
    key: 'readCountries',
  },
  {
    url: 'regions',
    key: 'readRegion',
  },
  {
    url: 'cities',
    key: 'readCities',
  },
  {
    url: 'emailtemplate',
    key: 'readEmailTemplate',
  },
  {
    url: 'analytics',
    key: 'readAnalytics',
  },
];

const urlAllow = (permissions, u = '') => {
  const url = u || window.location.href;
  let value = true;
  const ext = roleUrl?.find((itm) => url.includes(itm.url));
  if (ext) value = permissions?.[ext.key];
  return value;
};

const permissionModel = { permissions, urlAllow };

export default permissionModel;
